import dispatcher from './dispatcher';
import reporting from './reporting';
import eai from './eai';
import { NavItemType } from 'models';
import { conditionalRoute } from 'routes/routeUtils';
import system from 'routes/menu-items/system';
import digiTwin from 'routes/menu-items/digiTwin';

export type MenuItemsCA = {
  canAccessUserPage: boolean;
  canAccessPartyPage: boolean;
  canAccessBalancingGroupPage: boolean;
  canAccessDeliveryPointPage: boolean;
  canAccessDevicePage: boolean;
  canAccessDeliveryContractPage: boolean;
  canAccessOnlineDispatchingPage: boolean;
  canAccessProductionPlanPage: boolean;
  canAccessConsumptionPlanPage: boolean;
  canAccessOperationCalendarPage: boolean;
  canAccessHxDashboardPage: boolean;
  canAccessRkDashboardPage: boolean;
  canAccessSystemImbalanceReportsPage: boolean;
  canAccessBalancingGroupReportsPage: boolean;
  canAccessDeliveryPointProductionPlanReportsPage: boolean;
  canAccessDeviceProductionPlanReportsPage: boolean;
  canAccessReportingPage: boolean;
  canAccessEventOverviewPage: boolean;
  canAccessEconomicBenefitEvaluationPage: boolean;
};

type GetMenuItemsProps = {
  menuItems?: MenuItemsCA;
};

const defaultMenuItems = {
  canAccessUserPage: true,
  canAccessPartyPage: true,
  canAccessBalancingGroupPage: true,
  canAccessDeliveryPointPage: true,
  canAccessDevicePage: true,
  canAccessDeliveryContractPage: true,
  canAccessOnlineDispatchingPage: true,
  canAccessProductionPlanPage: true,
  canAccessConsumptionPlanPage: true,
  canAccessOperationCalendarPage: false, // hide breadcrumbs
  canAccessHxDashboardPage: true,
  canAccessRkDashboardPage: true,
  canAccessSystemImbalanceReportsPage: true,
  canAccessBalancingGroupReportsPage: true,
  canAccessDeliveryPointProductionPlanReportsPage: true,
  canAccessDeviceProductionPlanReportsPage: true,
  canAccessReportingPage: true,
  canAccessEventOverviewPage: true,
  canAccessEconomicBenefitEvaluationPage: true
};

// ==============================|| MENU ITEMS ||============================== //

const getMenuItems = ({
  menuItems = defaultMenuItems
}: GetMenuItemsProps): { items: NavItemType[] } => ({
  items: [
    dispatcher(menuItems),
    digiTwin(),
    ...conditionalRoute(reporting(menuItems), menuItems.canAccessReportingPage),
    eai(menuItems),
    ...conditionalRoute(system(menuItems), menuItems.canAccessEventOverviewPage)
  ]
});

export default getMenuItems;
